import React, { useEffect, useRef } from 'react';
import { Switch } from 'react-router-dom';
import { Container } from 'reactstrap';
import { useAuth } from 'react-oidc-context';
import axios from 'axios';
import PublicRoute from './features/Routes/PublicRoute';
import PrivateRoute from './features/Routes/PrivateRoute';
import AdminRoute from './features/Routes/AdminRoute';
import Header from './features/Navigation/Header';
import BreadCrumbContainer from './features/Breadcrumb/BreadcrumbContainer';
import InnmeldingPage from './features/Innmelding/InnmeldingPage';
import KontrollpanelContainer from './features/Kontrollpanel/KontrollpanelContainer';
import MapPage from './features/Driftskart/MapPage';
import Healthcheck from './features/Common/Healthcheck';
import LoginPage from './features/Login/LoginPage';
import Landingsside from './features/Landingsside/Landingsside';
import StatistikkContainer from './features/Statistikk/StatistikkContainer';
import WhoAmI from './features/WhoAmI/WhoAmI';
import Toast from './features/Common/Toast/toast';
import EntreprenorselskapAdmin from './features/Admin/EntreprenorselskapAdmin';
import Unauthorized from './features/Common/Unauthorized';
import { SesjonRedirectOverlay } from './features/Common/SesjonRedirectOverlay';

import './App.css';
import 'leaflet/dist/leaflet.css';
import Endpoints from './features/Admin/Endpoints';
import Helse from './features/Admin/Helse';
import DashboardContainer from './features/Dashboard/DashboardContainer';
import DashboardMonitorMapContainer from './features/Dashboard/DashboardMonitorMapContainer';
import DashboardDriftsstatistikkAktiveMaskiner from './features/Dashboard/DashboardDriftsstatistikkAktiveMaskiner';
import DashboardDriftsstatistikkUtfortTiltak from './features/Dashboard/DashboardDriftsstatistikkUtfortTiltak';
import InternalBymUserRoute from './features/Routes/InternalBymUserRoute';
import DashboardDriftsavvikMapContainer from './features/Dashboard/DashboardDriftsavvikMapContainer';

function App() {
  const auth = useAuth();
  const installPromptRef = useRef<Event | null>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      installPromptRef.current = e;
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const isMonitorMode = window.location.search.indexOf('monitor-mode') > 0;

  useEffect(() => {
    if (auth.isAuthenticated && auth.user?.access_token) {
      axios.defaults.headers.common.Authorization = `Bearer ${auth.user.access_token}`;
    } else {
      delete axios.defaults.headers.common.Authorization;
    }
  }, [auth.isAuthenticated, auth.user?.access_token]);

  if (auth.isLoading)
    return (
      <div className={`app${isMonitorMode ? ' monitor-mode' : ''}`}>
        <div>Vennligst vent...</div>
      </div>
    );
  return (
    <div className={`app${isMonitorMode ? ' monitor-mode' : ''}`}>
      <Header />
      <BreadCrumbContainer />
      <Toast />
      <SesjonRedirectOverlay />
      <Container id="page-container" fluid>
        <Switch>
          <PrivateRoute exact path="/" component={Landingsside} />
          <PublicRoute path="/login" component={LoginPage} />
          <PrivateRoute path="/kart/:fradato?/:tildato?" component={MapPage} />
          <PrivateRoute path="/innmelding" component={InnmeldingPage} />
          <PrivateRoute
            path="/kontrollpanel/:datofra?/:datotil?/:avvikId?"
            component={KontrollpanelContainer}
          />
          <PrivateRoute
            exact
            path="/statistikk/:gruppe?"
            component={StatistikkContainer}
          />
          <PrivateRoute exact path="/whoami" component={WhoAmI} />
          <InternalBymUserRoute
            path="/admin/dashboard/:monitor?"
            component={DashboardContainer}
          />
          <InternalBymUserRoute
            path="/admin/monitor_map/:monitor?"
            component={DashboardMonitorMapContainer}
          />
          <InternalBymUserRoute
            path="/admin/monitor_driftsavvik/monitor"
            component={DashboardDriftsavvikMapContainer}
          />
          <InternalBymUserRoute
            path="/admin/monitor_statistikk_drift_maskiner/:monitor?"
            component={DashboardDriftsstatistikkAktiveMaskiner}
          />
          <InternalBymUserRoute
            path="/admin/monitor_statistikk_drift_tiltak/:monitor?"
            component={DashboardDriftsstatistikkUtfortTiltak}
          />
          <AdminRoute path="/healthcheck" component={Healthcheck} />
          <AdminRoute
            path="/admin/entreprenorselskaper"
            component={EntreprenorselskapAdmin}
          />
          <AdminRoute path="/admin/endpoints" component={Endpoints} />
          <AdminRoute path="/admin/helse" component={Helse} />
          <PublicRoute path="/logout" component={Unauthorized} />
          <PublicRoute path="/unauth" component={Unauthorized} />
        </Switch>
      </Container>
    </div>
  );
}

export default App;
